import { cn } from "@/lib/chillnn/cn";

import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

type Props = {
	hasSortItem?: boolean;
	isSorting: boolean;
	showScConnectedColumn: boolean;
};

export const PlanListTableHeader = ({ hasSortItem, isSorting, showScConnectedColumn }: Props) => {
	return (
		<TableHeader>
			<TableRow className="hover:bg-white">
				<TableHead
					className={cn(
						"w-12", //
						(!hasSortItem || (hasSortItem && !isSorting)) && "hidden",
					)}
				/>
				<TableHead justifyStyle="center" className="w-72">
					プラン名
				</TableHead>
				<TableHead justifyStyle="center" className="w-28">
					ステータス
				</TableHead>
				{showScConnectedColumn ? (
					<TableHead justifyStyle="center" className="w-28">
						サイコン料金連携
					</TableHead>
				) : null}
				<TableHead justifyStyle="center" className="w-32">
					残在庫
				</TableHead>
				<TableHead justifyStyle="end" className="w-48">
					単価
				</TableHead>
				<TableHead justifyStyle="center" className="w-48">
					操作
				</TableHead>
			</TableRow>
		</TableHeader>
	);
};

PlanListTableHeader.displayName = "PlanListTableHeader";
